export interface BackendError {
  success: false;
  error: {
    message: string;
    code: string;
    details?: any[];
  };
}

export interface ApiErrorResponse {
  status: number;
  statusText: string;
  data: BackendError;
}

export interface ErrorContext {
  operation: string;
  component?: string;
  timestamp: number;
  userId?: string;
}

export enum ErrorSeverity {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical'
}

export enum ErrorCategory {
  AUTHENTICATION = 'authentication',
  AUTHORIZATION = 'authorization',
  VALIDATION = 'validation',
  NETWORK = 'network',
  SERVER = 'server',
  CLIENT = 'client',
  UNKNOWN = 'unknown'
}

export interface ProcessedError {
  id: string;
  message: string;
  userMessage: string;
  code: string;
  status: number;
  severity: ErrorSeverity;
  category: ErrorCategory;
  context: ErrorContext;
  timestamp: number;
  retryable: boolean;
  originalError: any;
}

export interface ErrorHandlingConfig {
  showToast: boolean;
  logToConsole: boolean;
  logToServer: boolean;
  retryAttempts: number;
  retryDelay: number;
  autoLogout: boolean;
}

export const DEFAULT_ERROR_CONFIG: ErrorHandlingConfig = {
  showToast: true,
  logToConsole: true,
  logToServer: true,
  retryAttempts: 3,
  retryDelay: 1000,
  autoLogout: false,
};

// Specific error codes for handling
export const ERROR_CODES = {
  NO_ROLES: 'NO_ROLES',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
} as const; 